import React from 'react';
import Slider from 'react-slick';

const CategoriesSection = () => {
  const settings = {
    dots: true, // Enable dots navigation
    infinite: true, // Infinite loop of slides
    speed: 500, // Transition speed
    autoplay: true, // Auto sliding
    autoplaySpeed: 3000, // Speed of auto sliding
    slidesToShow: 3, // Default to 1 image per slide
    slidesToScroll: 1, // Scroll one item at a time
    nextArrow: <div className="next-arrow">Next</div>, // Customize next arrow
    prevArrow: <div className="prev-arrow">Prev</div>, // Customize previous arrow

    // Responsive settings for different screen sizes
    responsive: [
      {
        breakpoint: 1024, // Medium screen and larger
        settings: {
          slidesToShow: 3, // Show 3 items on medium screens and above
          slidesToScroll: 3, // Scroll 3 items at a time
        },
      },
      {
        breakpoint: 600, // Small screen
        settings: {
          slidesToShow: 1, // Show 1 item on smaller screens
          slidesToScroll: 1, // Scroll 1 item at a time
        },
      },
    ],
  };

  return (
   <div className='container'>

<div className="section-full p-t150 site-bg-white twm-categories-section-wrap wow fadeInDown" data-wow-offset="100" data-wow-delay="0.2">
      <div className="container pb-5">
        <div className="row">
          <div className="col-lg-6 col-md-12 ">
            {/* Title Section */}
            <div className="section-head left">
              <div className="twm-sm-title left">Categories</div>
              <h2 className="twm-large-title site-text-dark">A Look At All Types Of Vehicles</h2>
            </div>
          </div>
        </div>

        <div className="section-content container ">
          <Slider {...settings}>
            {/* One block */}
            <div className="item ">
              <div className="twm-categories-type">
                <div className="twm-media">
                  <img src="/images/our-fleet/18.webp" alt="SUV" />
                  <div className="twm-media-link">
                    <a href="cars-detail.html" className="twm-media-link-content">SUV</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Two block */}
            <div className="item p-1">
              <div className="twm-categories-type">
                <div className="twm-media">
                  <img src="/images/our-fleet/19.webp" alt="Sedan" />
                  <div className="twm-media-link">
                    <a href="cars-detail.html" className="twm-media-link-content">Sedan</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Three block */}
            <div className="item p-1">
              <div className="twm-categories-type">
                <div className="twm-media">
                  <img src="/images/our-fleet/20.webp" alt="Harley Davidson" />
                  <div className="twm-media-link">
                    <a href="cars-detail.html" className="twm-media-link-content">Harley Davidson</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Four block */}
            <div className="item p-1">
              <div className="twm-categories-type">
                <div className="twm-media">
                  <img src="/images/our-fleet/24.jpg" alt="Hatchback" />
                  <div className="twm-media-link">
                    <a href="cars-detail.html" className="twm-media-link-content">Hatchback</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Five block */}
            <div className="item p-1">
              <div className="twm-categories-type">
                <div className="twm-media">
                  <img src="/images/our-fleet/22.webp" alt="Coupe" />
                  <div className="twm-media-link">
                    <a href="cars-detail.html" className="twm-media-link-content">Coupe</a>
                  </div>
                </div>
              </div>
            </div>

            {/* Six block */}
            <div className="item p-1">
              <div className="twm-categories-type">
                <div className="twm-media">
                  <img src="/images/our-fleet/8.jpg" alt="Hybrid" />
                  <div className="twm-media-link">
                    <a href="cars-detail.html" className="twm-media-link-content">Hybrid</a>
                  </div>
                </div>
              </div>
            </div>

          </Slider>
        </div>
      </div>
    </div>

   </div>
  );
};

export default CategoriesSection;
